<div class="error-page">
  <fmnts-empty-state>
    <fmnts-empty-state-visual>
      <fa-icon [icon]="_iconNotFound" size="lg"></fa-icon>
    </fmnts-empty-state-visual>

    <fmnts-empty-state-title>
      {{ 'page_not_found_title' | translate }}
    </fmnts-empty-state-title>

    <fmnts-empty-state-description>
      {{ 'donor_feedback_not_found' | translate }}
      <br />

      <ul>
        <li>{{ 'donor_feedback_anonymized' | translate }}</li>
        <li>{{ 'donor_feedback_incorrect_link' | translate }}</li>
      </ul>
    </fmnts-empty-state-description>
  </fmnts-empty-state>
</div>
